import React from 'react'
import ReactDOM from 'react-dom/client'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import App from './App.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SafeAreaProvider>
      <App />
    </SafeAreaProvider>
  </React.StrictMode>,
)